import {ModalFooter} from '_core/components/Modal'
import React, {useState} from 'react'
import ShippingMethodItem from './ShippingMethodItem'
import {OrderModal} from '../../view/orderModal/OrderModal'

interface Props {
  onClose: () => void
  isFetching: boolean
  shippingMethods: any[]
  onShippingMethodChange: (shippingMethod: any) => void
  selectedRateId?: string
  children?: React.ReactNode
  customRate: any
}

const pageSize = 5
export const ShippingMethodsDialog: React.FC<Props> = ({
  onClose,
  isFetching,
  shippingMethods,
  children,
  customRate,
  ...props
}) => {
  const [currentPage, setCurrentPage] = useState(1)
  const handlePageChange = (currentPage: any) => {
    setCurrentPage(currentPage)
  }
  const lastIndex = pageSize * currentPage
  const firstIndex = lastIndex - pageSize

  return (
    <OrderModal
      hideFooter
      onClose={onClose}
      title='Select Shipping Rate'
      icon='delivery-van'
      pagination={{
        totalCount: shippingMethods.length,
        isDisableResetPaging: true,
        currentPage,
        onPageChange: handlePageChange,
        pageSize,
      }}
      footer={
        <ModalFooter
          className='d-flex flex-nowrap gap-3'
          close={{
            id: 'btnCancel',
            onClick: onClose,
            className: 'btn explore-btn-outline w-100',
            text: 'Cancel',
          }}
        >
          {children}
        </ModalFooter>
      }
    >
      <div className='row gy-5 gx-xl-8'>
        {shippingMethods.length ? (
          <div className='col-xl-12'>
            {shippingMethods
              .slice(firstIndex, lastIndex)
              .map((shippingMethod: any, index: number) => (
                <ShippingMethodItem shippingMethod={shippingMethod} key={index} {...props} />
              ))}
            {customRate && <div className='mb-5'>{customRate}</div>}
          </div>
        ) : (
          <span className='text-danger text-xl-center py-10'>
            No shipping method available for this address. <br />
            Please create shipping method to this area in shipping and delivery setting.
          </span>
        )}
      </div>
    </OrderModal>
  )
}

export default ShippingMethodsDialog
